import { http, Chain, Transport } from 'viem'
import { VIEM_TIMEOUT_ON_FORKS } from '@/config/consts'
import { instrumentTransport } from '@/domain/perf'
import { getInjectedNetwork } from './getInjectedNetwork'
import { hyperEVM, SUPPORTED_CHAINS } from '../chain/constants'
import { fallback } from 'wagmi'

export interface GetTransportsParamsOptions {
  forkChain?: Chain
  baseDevNetChain?: Chain
}

export type GetTransportsResult = Record<number, Transport>

export function getTransports({ forkChain, baseDevNetChain }: GetTransportsParamsOptions): GetTransportsResult {
  const transports: Record<number, Transport> = {}

  // Dynamically generate transports for all supported chains
  for (const chain of SUPPORTED_CHAINS) {
    const rpcUrl = chain.rpcUrls.default.http[0]

    if (chain.id === hyperEVM.id) {
      const [defaultRpc, fallbackRpc] = hyperEVM.rpcUrls.default.http
      transports[chain.id] = instrumentTransport(fallback([http(defaultRpc), http(fallbackRpc)]))
    } else {
      // Use standard http transport for other chains (ETH, Arbitrum, Optimism)
      transports[chain.id] = instrumentTransport(http(rpcUrl))
    }
  }

  if (forkChain) {
    transports[forkChain.id] = instrumentTransport(
      http(forkChain.rpcUrls.default.http[0], { timeout: VIEM_TIMEOUT_ON_FORKS }),
    )
  }

  if (baseDevNetChain) {
    transports[baseDevNetChain.id] = instrumentTransport(http(baseDevNetChain.rpcUrls.default.http[0]))
  }

  if (process.env.NEXT_PUBLIC_FEATURE_RPC_INJECTION_VIA_URL === '1') {
    const injectedNetwork = getInjectedNetwork()
    if (injectedNetwork) {
      transports[injectedNetwork.chainId] = instrumentTransport(http(injectedNetwork.rpc))
    }
  }

  return transports
}
